import { render, staticRenderFns } from "./breakpoints.vue?vue&type=template&id=57b40fe0&scoped=true&"
import script from "./breakpoints.vue?vue&type=script&lang=js&"
export * from "./breakpoints.vue?vue&type=script&lang=js&"
import style0 from "./breakpoints.vue?vue&type=style&index=0&id=57b40fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b40fe0",
  null
  
)

export default component.exports